import React from "react";
import { ServiceEmirates } from "../../types/serviceDetail";

interface Props {
  serviceEmirates?: ServiceEmirates[];
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ServiceEmirateSingle: React.FC<Props> = ({
  serviceEmirates,
  sectionTitle,
  line,
  isPage = false,
}) => {
  const renderTitle = (title: string | null) => {
    if (!title) return null;
    const TitleTag = isPage ? "h3" : "p";
    return (
      <TitleTag
        className="text-center font-16 text-black ff-semibold mb-4"
        dangerouslySetInnerHTML={{ __html: title }}
      />
    );
  };

  const renderLine = (line: string | null) => {
    if (!line) return null;
    return (
      <p
        className="font-12 text-grey ff-normal text-center"
        dangerouslySetInnerHTML={{ __html: line }}
      />
    );
  };

  return (
    <section className="py-5 my-3  amer-wrap-emirate">
      <div className="container p-0 ">
        {renderTitle(sectionTitle)}
        {renderLine(line)}

        <div className="row g-3 justify-content-center custom-image-list emirates-all">
          {serviceEmirates?.map((item, index) => (
            <div
              className="col-md-12  custom-image-item text-center"
              key={index}
            >
              {item.img_url && (
                <img
                  src={item.img_url}
                  alt={item.alt ?? "Service Image"}
                  className="img-fluid"
                />
              )}
              {/* <p className="mt-2 fw-bold custom-image-text">
                {item.title ?? ""}
              </p> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceEmirateSingle;
